import { NewOrderReview } from 'smg/customer-api/orders';
import Modal from 'smg/modal';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import i18n from '../i18n';

// PromptReview opens the write-a-review modal (star rating + comments) and
// submits through our customer-api, which forwards to reviews.io server-side —
// no third-party widget or script on the page (#6912). The page must render
// the `review-widget` shortcode, which holds the modal body templates.
export function PromptReview(orderKey: string) {
    const $body = template.Clone('#review-widget-template').firstElementChild as HTMLElement;
    const $stars = $body.querySelector('.review-stars') as HTMLElement;
    const $ratingInput = $body.querySelector('.review-rating-input') as HTMLInputElement;
    const $ratingLabel = $body.querySelector('.review-rating-label') as HTMLElement;
    const $comments = $body.querySelector('textarea[name=comments]') as HTMLTextAreaElement;

    ($body.querySelector('.review-prompt') as HTMLElement).textContent = i18n('reviewModalPrompt');
    ($body.querySelector('.review-comments-label') as HTMLElement).textContent = i18n('reviewCommentsLabel');
    ($body.querySelector('.review-comments-min') as HTMLElement).textContent = i18n('reviewCommentsMin');

    const ratingLabels = [i18n('reviewRating1'), i18n('reviewRating2'), i18n('reviewRating3'), i18n('reviewRating4'), i18n('reviewRating5')];
    let rating = 0;

    const $starButtons: HTMLButtonElement[] = [];
    const paint = (n: number) => {
        $starButtons.forEach(($star, i) => {
            $star.classList.toggle('review-star-filled', i < n);
        });
        if (n > 0) {
            $ratingLabel.textContent = ratingLabels[n - 1];
            $ratingLabel.classList.remove('d-none');
        } else {
            $ratingLabel.classList.add('d-none');
        }
    };

    for (let i = 1; i <= 5; i++) {
        const $starWrapper = template.Clone('#review-star-template').firstElementChild as HTMLElement;
        const $star = $starWrapper.querySelector('button') as HTMLButtonElement;
        $star.ariaLabel = `${i} star${i === 1 ? '' : 's'}`;
        $star.addEventListener('click', () => {
            rating = i;
            $ratingInput.value = String(i);
            paint(i);
        });
        $star.addEventListener('mouseenter', () => paint(i));
        $star.addEventListener('mouseleave', () => paint(rating));
        $starButtons.push($star);
        $stars.appendChild($starWrapper);
    }

    new Modal({
        title: i18n('reviewModalTitle'),
        headerLevel: 'h2',
        body: $body,
        confirmText: i18n('reviewSubmit'),
        cancelText: i18n('reviewNoThanks'),
        confirmButtonClass: 'btn btn-primary m-0',
        cancelButtonClass: 'btn btn-outline-primary m-0',
        appendBodyClass: 'p-4 px-md-8',
        appendClassBySelector: {
            '.modal-footer': 'justify-content-center flex-row-reverse gap-4',
        },
        onSubmit: async () => {
            await NewOrderReview(orderKey, { rating, comments: $comments.value });
            toast.Success(i18n('reviewThanks'));
        },
    });
}
